import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App";
import AOS from "aos";
import "aos/dist/aos.css";
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheckCircle, MdChildCare, MdFavorite, MdFemale, MdHealthAndSafety, MdHome, MdLightMode, MdLocationPin, MdOutlineAssessment, MdOutlineSavings, MdSearch, MdVerified } from "react-icons/md";

import logo from '../assets/logo_icon.png';
import values from '../assets/values.jpg';
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneObjective from "./OneObjective";
import HomeSlider from "./HomeSlider";
import CustomersHighlight from "./CustomersHighlight";
import HomeBanner1 from "./HomeBanner1";
import AboutCompany from "./AboutCompany";
import PageTitle from "./PageTitle";

export default function AboutUsContent(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}


	

	useEffect(() => {
		init();
	}, [ ])


	useEffect(() => {
		AOS.init({
		duration: 2000,
		easing: "ease-out",
		once: false,
		});
	}, []);


	if(ready) {
		return (
			<>
				<PageTitle title="About Us" />
				<AboutCompany/>
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div 
								className="col-md-4 text-center mb-3 mt-3"
							>
								<img
									src={logo} height={200}
								/>
							</div>

							<div className="col-md-4 mt-3 mb-3 px-5">
								
								<h3 
									className="text-primary font-bold"
									
								>
									Mission:
								</h3>

								<p
									style={{
										textAlign:"justify"
									}}
								>
									To promote the general well-being of Vulnerable groups (Children, Adolescent, Youth, women and elderly) by assisting their families and concerned community members in providing attention, care, education, vocational skills and psychosocial support for all aspects of their lives.
								</p>
								
							</div>

							<div className="col-md-4 mt-3 mb-3 px-5">

								<h3 
									className="text-primary font-bold"
									
								>
									Vision:
								</h3>

								<p
									style={{
										textAlign:"justify"
									}}
								>
									Realization of quality health, safety, and well-improved dignified Tanzanian Vulnerable groups and keep them free from poverty.
								</p>

							</div>

						</div>
					</div>
				</div>
				<HomeBanner1/>

				<div className="main-body-section">
					<div className="container py-5">
						<div className="row d-flex align-items-center">
							<div 
							  className="col-md-6 mb-5"
							>
								<img 
									src={values} 
									style={{
										width:"100%"
									}}
									data-aos="fade-down"
								/>
							</div>
							<div className="col-md-6 mb-5">

								<h3 
									className="text-primary font-bold mb-3"
									
								>
									Core Values:
								</h3>

								<h5>
									<MdVerified size="32" className="text-secondary"/>
									<span className="ms-3">We encourage self-discipline</span>
								</h5>
								<h5>
									<MdVerified size="32" className="text-secondary"/>
									<span className="ms-3">We value Transparency and Accountability</span>
								</h5>
								<h5>
									<MdVerified size="32" className="text-secondary"/>
									<span className="ms-3">We Value Good Leadership</span>
								</h5>
								<h5>
									<MdVerified size="32" className="text-secondary"/>
									<span className="ms-3">We esteem entrepreneurship and Innovations</span>
								</h5>
								<h5>
									<MdVerified size="32" className="text-secondary"/>
									<span className="ms-3">We are inclusive, Impartial and non-discriminatory</span>
								</h5>
								<h5>
									<MdVerified size="32" className="text-secondary"/>
									<span className="ms-3">We value Partnership</span>
								</h5>

							</div>
						</div>
					</div>
				</div>

				<CustomersHighlight/>

				<div className="main-body-section bg-surface">
					<div className="container py-5">
						<div className="row">
							
							<div className="col-md-12 py-5">

								<h3 
									className="text-primary font-bold mb-3"
									
								>
									Objectives:
								</h3>
								<h5
									className="text-muted font-bold mb-5"
								>
									In line with its mission, TCHI seeks to achieve the following objectives:
								</h5>
								
								<div className="row g-3">

									<div className="col-md-6">
										<div className="">
											<OneObjective 
											icon={<MdChildCare size={48} />} 
											content="Support for MVCs" 
											description="Reach and provide comprehensive support to at least 1000 MVCs by September 2026." 
											/>
										</div>
									</div>

									<div className="col-md-6">
										<div className="">
											<OneObjective 
											icon={<MdOutlineSavings size={48} />} 
											content="Maternal and child health outcomes" 
											description="Enhance the economic stability of MVC households through income-generating initiatives and financial literacy programs."
											/>
										</div>
									</div>

									<div className="col-md-6">
										<div className="">
											<OneObjective 
											icon={<MdHealthAndSafety size={48} />} 
											content="Maternal and Child Health & AGYW Empowerment" 
											description="Improve maternal and child health outcomes while empowering AGYW with education, skills, and leadership opportunities." 
											/>
										</div>
									</div>

									<div className="col-md-6">
										<div className="">
											<OneObjective 
											icon={<MdFemale size={48} />} 
											content="Women’s Economic Empowerment:" 
											description="Expand women’s access to economic opportunities, entrepreneurship, and sustainable livelihoods."
											/>
										</div>
									</div>

									<div className="col-md-6">
										<div className="">
											<OneObjective 
											icon={<MdFavorite size={48} />} 
											content="HIV Prevention and Care" 
											description="Implement comprehensive HIV prevention, treatment, and support services for affected populations." 
											/>
										</div>
									</div>

									<div className="col-md-6">
										<div className="">
											<OneObjective 
											icon={<MdOutlineAssessment size={48} />} 
											content="Research, Monitoring, and Evaluation" 
											description="Strengthen research, monitoring, evaluation, collaboration, and adaptability for effective, evidence-based programming."
											/>
										</div>
									</div>

								</div>


							</div>
						</div>
					</div>
				</div>

			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}